import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { SharedModule} from './shared/shared.module';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppComponent } from './app.component';

import { TealiumhelperService} from './shared/analytics/tealiumhelper/tealiumhelper.service';
import { TealiumdataService} from './shared/analytics/tealiumdata/tealiumdata.service';
import { ConfigService } from './shared/config/config/config.service';
import { UtilityCookieService} from './shared/utils/cookie/utilitycookie.service';
import { ApiService } from './shared/services/api/api.service';
import { SpinnerService } from './shared/services/spinner/spinner.service';
import { NgbModalModule } from './shared/components/modal/modal.module';
import { StorageService} from './shared/services/storage/storage.service';

import localeUS from '@angular/common/locales/en';
import localeUSExtra from '@angular/common/locales/extra/en';
import {DatePipe, registerLocaleData} from '@angular/common';
import { CvsHttpModule } from './shared/modules/cvs-http/cvs-http.module';
import {AccordionComponent} from './shared/uikit/accordion';

registerLocaleData(localeUS, 'en', localeUSExtra);


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientJsonpModule,
    HttpClientModule,
    NgbModalModule,
    CvsHttpModule.forRoot(),
    SharedModule
  ],
  providers: [
    TealiumhelperService,
    TealiumdataService,
    DeviceDetectorService,
    UtilityCookieService,
    ConfigService,
    ApiService,
    SpinnerService,
    StorageService,
    DatePipe,
    AccordionComponent
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
